import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
// import "../../../../../assets/css/calendar.css";
import CalendarModal from "components/modelpopup/CalendarModal";
import { getLeaveCalenderApi, getLeaveTeamApi } from "api/services/leave";
import FilterSelect from "components/Form/filterSelect";
import { Spin } from "antd"; // Ant Design loading spinner
import { formatDateHandler2 } from "utils/common";
import { useSelector } from 'react-redux';

const Calendar = () => {
  const [weekendsVisible] = useState(true);
  const [calendarData, setCalendarData] = useState([]);
  const [calendarLoading, setCalendarLoading] = useState(false);
  const [calendarYear, setCalendarYear] = useState(new Date().getFullYear());
  const [monthList] = useState([
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" }
  ]);
  const [calendarMonth, setCalendarMonth] = useState(monthList[new Date().getMonth()]);

  const [leaveType, setLeaveType] = useState([]);
  const [leaveColor, setLeaveColor] = useState({});
  const [defaultEvents, setDefaultEvents] = useState([]);
  const [teamData, setTeamData] = useState([]);

  const [leaveTypeTeam, setLeaveTypeTeam] = useState([]);
  const [leaveColorTeam, setLeaveColorTeam] = useState({});

  // Get current year
  const currentYear = new Date().getFullYear();
  
  // Generate year list from 2025 to current year + 4
  const [yearList] = useState(() => {
    const startYear = 2025;
    const endYear = currentYear + 3;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year.toString());
    }
    return years;
  });

  const { userData, department, costCenter } = useSelector((state) => state.common);
  // Separate states for year view and team view user selection
  const [selectedUser, setSelectedUser] = useState(null); // For year view (single select)
  const [selectedTeamUsers, setSelectedTeamUsers] = useState([]); // For team view (multi select)
  
  // New state for department and cost center filters
  const [selectedDepartment, setSelectedDepartment] = useState(null); // For year view
  const [selectedCostCenter, setSelectedCostCenter] = useState(null); // For year view
  const [selectedTeamDepartment, setSelectedTeamDepartment] = useState(null); // For team view
  const [selectedTeamCostCenter, setSelectedTeamCostCenter] = useState(null); // For team view
  
  // Filtered user lists based on department/cost center selection
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filteredTeamUsers, setFilteredTeamUsers] = useState([]);

  // Format options for dropdowns
  const departmentOptions = department?.map(dept => ({
    value: dept.id,
    label: dept.name
  })) || [];
  
  const costCenterOptions = costCenter?.map(cc => ({
    value: cc.id,
    label: cc.code
  })) || [];

  // Filter users based on department and cost center selections
  useEffect(() => {
    let filtered = [...userData || []];
    console.log(filtered,filtered.length, selectedDepartment, selectedCostCenter);
    
    if (selectedDepartment) {
      filtered = filtered.filter(user => 
        user.employment?.department === selectedDepartment.value
      );
    }
    
    if (selectedCostCenter) {
      filtered = filtered.filter(user => 
        user.cost_center === selectedCostCenter.value
      );
    }
    
    console.log(filtered.length);

    setFilteredUsers(filtered.map(user => ({
      value: user.id,
      label: `${user.first_name} ${user.last_name}`
    })));
    
    // Reset selected user if not in filtered list
    if (selectedUser && !filtered.some(user => user.id === selectedUser.value)) {
      setSelectedUser(null);
    }
  }, [userData, selectedDepartment, selectedCostCenter]);
  
  // Filter team users based on department and cost center selections
  useEffect(() => {
    let filtered = [...userData || []];
    
    if (selectedTeamDepartment) {
      filtered = filtered.filter(user => 
        user.employment?.department === selectedTeamDepartment.value
      );
    }
    
    if (selectedTeamCostCenter) {
      filtered = filtered.filter(user => 
        user.cost_center === selectedTeamCostCenter.value
      );
    }
    
    setFilteredTeamUsers(filtered.map(user => ({
      value: user.id,
      label: `${user.first_name} ${user.last_name}`
    })));
    
    // Filter selected team users to only include those in the filtered list
    if (selectedTeamUsers.length > 0) {
      const validUserIds = filtered.map(user => user.id);
      const newSelectedUsers = selectedTeamUsers.filter(user => 
        validUserIds.includes(user.value)
      );
      
      if (newSelectedUsers.length !== selectedTeamUsers.length) {
        setSelectedTeamUsers(newSelectedUsers);
      }
    }
  }, [userData, selectedTeamDepartment, selectedTeamCostCenter]);

  useEffect(() => {
    setCalendarLoading(true);
    getLeaveCalenderApi({ 
      year: calendarYear,
      company_user: selectedUser?.value || '', // Single user ID
      department: selectedDepartment?.value || '',
      cost_center: selectedCostCenter?.value || ''
    })
      .then((response) => {
        setCalendarYear(response.data.year);
        setLeaveType(response.data.leave_type);
        setLeaveColor(response.data.colors);
        setDefaultEvents(response.data.leave_days);
        setCalendarLoading(false);
      })
      .catch((err) => {
        setCalendarLoading(false);
      });
  }, [calendarYear, selectedUser, selectedDepartment, selectedCostCenter]);

  useEffect(() => {
    setCalendarLoading(true);
    getLeaveTeamApi({ 
      year: calendarYear, 
      month: calendarMonth.value,
      company_user: selectedTeamUsers.map(user => user.value).join(','),
      department: selectedTeamDepartment?.value || '',
      cost_center: selectedTeamCostCenter?.value || ''
    })
      .then((response) => {
        setLeaveTypeTeam(response.data.leave_type);
        setLeaveColorTeam(response.data.colors);
        setTeamData(response.data.data);
        setCalendarLoading(false);
      })
      .catch((err) => {
        setCalendarLoading(false);
      });
  }, [calendarYear, calendarMonth, selectedTeamUsers, selectedTeamDepartment, selectedTeamCostCenter]);

  //   const defaultEvents = [
  //     {
  //       title: "AL",
  //       start: Date.now() + 148000000,
  //       className: "bg-purple",
  //     },
  //     {
  //       title: "SL",
  //       start: Date.now(),
  //       end: Date.now(),
  //       className: "bg-success",
  //     },

  //     {
  //       title: "AL",
  //       start: Date.now() + 338000000,
  //       className: "bg-primary",
  //     },
  //   ];

  // Generate month labels and FullCalendar components for each month
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Helper function to generate the days for a given month
  const generateMonthDays = (monthIndex) => {
    const date = new Date(calendarYear, monthIndex, 1); // Start of the month
    const daysInMonth = new Date(calendarYear, monthIndex + 1, 0).getDate(); // Last day of the month

    const days = [];
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(day); // Push each day of the month
    }

    return days;
  };

  // Helper function to get events for a specific month
  const getMonthEvents = (monthIndex) => {
    return defaultEvents.filter((event) => {
      const eventMonth = new Date(event.start).getMonth();
      return eventMonth === monthIndex;
    });
  };
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* Page Header */}
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col">
              <h3 className="page-title">Leave View</h3>
              
            </div>
            {/* <div className="col-auto float-end ms-auto">
              <Link
                to="#"
                className="btn add-btn"
                data-bs-toggle="modal"
                data-bs-target="#add_event"
              >
                <i className="fa-solid fa-plus" /> Add Event
              </Link>
            </div> */}
          </div>
        </div>
        {/* /Page Header */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card mb-0">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    {/* Calendar */}
                    <div id="calendar" />

                    <div className="w-100 mb-1 d-flex justify-content-between align-items-end">
                      <h4>Year View</h4>
                      <div className="d-flex gap-2">
                        <FilterSelect
                          className={"me-2"}
                          optionLabel={"label"}
                          optionValue="value"
                          placeholder={"Select department"}
                          value={selectedDepartment}
                          options={departmentOptions}
                          onChange={(e) => setSelectedDepartment(e)}
                          isMulti={false}
                        />
                        <FilterSelect
                          className={"me-2"}
                          optionLabel={"label"}
                          optionValue="value"
                          placeholder={"Select cost center"}
                          value={selectedCostCenter}
                          options={costCenterOptions}
                          onChange={(e) => setSelectedCostCenter(e)}
                          isMulti={false}
                        />
                        <FilterSelect
                          className={"me-2"}
                          optionLabel={"label"}
                          optionValue="value"
                          placeholder={"Select employee"}
                          value={selectedUser}
                          options={filteredUsers.length > 0 ? filteredUsers : userData?.map(user => ({
                            value: user.id,
                            label: `${user.first_name} ${user.last_name}`
                          })) || []}
                          onChange={(e) => setSelectedUser(e)}
                          isMulti={false} // Single select for year view
                        />
                        <FilterSelect
                          optionLabel={"label"}
                          optionValue="value"
                          placeholder={"Select year"}
                          value={{ value: calendarYear, label: calendarYear }}
                          options={yearList.map((item) => {
                            return { value: item, label: item };
                          })}
                          onChange={(e) => setCalendarYear(e.value)}
                        />
                      </div>
                    </div>
                    {/* Show loading spinner when loading */}
                    {calendarLoading && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          zIndex: 10,
                        }}
                      >
                        <Spin size="large" />
                      </div>
                    )}

                    <div className="overflow-scroll">
                      <table
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                // padding: "10px",
                                border: "1px solid #ddd",
                                fontSize: 12,
                              }}
                            >
                              Month
                            </td>
                            {Array.from({ length: 31 }, (_, i) => (
                              <td
                                key={i}
                                style={{
                                  textAlign: "center",
                                  //   padding: "10px",
                                  border: "1px solid #ddd",
                                  backgroundColor: "#f4f4f4",
                                }}
                              >
                                {i + 1}
                              </td>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {/* Render each month as a row */}
                          {months.map((month, monthIndex) => (
                            <tr key={monthIndex}>
                              <td
                                style={{
                                  textAlign: "center",
                                  //   padding: "10px",
                                  //   fontWeight: "bold",
                                  backgroundColor: "#f4f4f4",
                                  border: "1px solid #ddd",
                                  fontSize: 12,
                                }}
                              >
                                {month}
                              </td>

                              {/* Render days for each month */}
                              {Array.from({ length: 31 }, (_, dayIndex) => {
                                const days = generateMonthDays(monthIndex);
                                const currentDay = days[dayIndex];

                                return (
                                  <td
                                    key={dayIndex}
                                    style={{
                                      border: "1px solid #ddd",
                                      width:30,
                                      height:30,
                                      textAlign: "center",
                                    //   paddingLeft: "8px",
                                    //   paddingRight: "8px",
                                      //   height: "50px",
                                    //   verticalAlign: "top",
                                      
                                    }}
                                  >
                                    {currentDay ? (
                                      <>
                                        {/* <div>{currentDay}</div> */}
                                        {/* Render events for that day */}
                                        {getMonthEvents(monthIndex)
                                          .filter(
                                            (event) =>
                                              new Date(
                                                event.start
                                              ).getDate() === currentDay
                                          ).slice(0,1)
                                          .map((event, eventIndex) => (
                                            <div
                                            className="w-100 h-100 d-flex justify-content-center align-items-center"
                                            data-toggle="tooltip"
                                             data-placement="top" 
                                            data-html="true"
                                            // title="<em>Tooltip</em> <u>with</u> <b>HTML</b>"
                                            title={`${event.code}  (${ formatDateHandler2(event.start_date) } - ${formatDateHandler2(event.end_date)})`}
                                              key={eventIndex}
                                              style={{
                                                backgroundColor:
                                                  event.eventBackgroundColor, // Event background color
                                                color: event.eventTextColor, // Event text color
                                                fontSize: "10px",
                                                // padding: "2px",
                                                // marginTop: "2px",
                                                // borderRadius: "4px",
                                              }}
                                            >
                                                
                                              {event.short_code}
                                            </div>
                                          ))}
                                      </>
                                    ) : (
                                      <div>&nbsp;</div> // Empty cell for days that don't exist in the month
                                    )}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="row mt-2 ">
                      {leaveType.map((leave, index) => (
                        <div key={index} className="col-md-4 col-lg-3 col-sm-2  ">
                          <p className="" style={{ fontSize: "10px" }}>
                            {leave.short_code} - {leave.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <div className="row mt-2 ">
                      {Object.entries(leaveColor).map(
                        ([status, color], index) => (
                          <div key={index} className="col-md-4  mb-1">
                            <div className="d-flex align-items-center">
                              <div
                                style={{
                                  height: "20px",
                                  width: "20px",
                                  backgroundColor: color,
                                  color: "#fff",
                                  // borderRadius: "8px",
                                  // fontWeight: "bold",
                                }}
                              />
                              <span className="ms-1" style={{ fontSize: 10 }}>
                                {status}
                              </span>
                            </div>
                          </div>
                        )
                      )}
                    </div>

                    <div className="w-100 mb-1 d-flex justify-content-between align-items-end mt-2">
                      <h4>Team View</h4>
                      <div className="d-flex gap-2">
                        <FilterSelect
                          className={"me-2"}
                          optionLabel={"label"}
                          optionValue="value"
                          placeholder={"Select department"}
                          value={selectedTeamDepartment}
                          options={departmentOptions}
                          onChange={(e) => setSelectedTeamDepartment(e)}
                          isMulti={false}
                        />
                        <FilterSelect
                          className={"me-2"}
                          optionLabel={"label"}
                          optionValue="value"
                          placeholder={"Select cost center"}
                          value={selectedTeamCostCenter}
                          options={costCenterOptions}
                          onChange={(e) => setSelectedTeamCostCenter(e)}
                          isMulti={false}
                        />
                        <FilterSelect
                          className={"me-2"}
                          optionLabel={"label"}
                          optionValue="value"
                          placeholder={"Select employees"}
                          value={selectedTeamUsers}
                          options={filteredTeamUsers.length > 0 ? filteredTeamUsers : userData?.map(user => ({
                            value: user.id,
                            label: `${user.first_name} ${user.last_name}`
                          })) || []}
                          onChange={(e) => setSelectedTeamUsers(e)}
                          isMulti={true} // Multi select for team view
                        />
                        <FilterSelect
                          className={"me-2"}
                          optionLabel={"label"}
                          optionValue="value"
                          placeholder={"Select month"}
                          value={calendarMonth}
                          options={monthList}
                          onChange={(e) => setCalendarMonth(e)}
                        />
                        <FilterSelect
                          optionLabel={"label"}
                          optionValue="value"
                          placeholder={"Select year"}
                          value={{ value: calendarYear, label: calendarYear }}
                          options={yearList.map((item) => {
                            return { value: item, label: item };
                          })}
                          onChange={(e) => setCalendarYear(e.value)}
                        />
                      </div>
                    </div>

                    <div className="overflow-scroll">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <td rowSpan={2} style={{ fontSize: 12 }}>
                              Employee Code
                            </td>
                            <td rowSpan={2} style={{ fontSize: 12 }}>
                              Employee Name
                            </td>
                            <td rowSpan={2} style={{ fontSize: 12 }}>
                              {" "}
                              Position
                            </td>
                            <td
                              colSpan={31}
                              style={{ fontSize: 12 }}
                              align="center"
                            >
                              {calendarMonth.label} {calendarYear}
                            </td>
                            {/* Generate headers for each day of the month (1-31) */}
                            {/* {[...Array(31)].map((_, index) => (
              <td key={index + 1}>{index + 1}</td>
            ))} */}
                          </tr>
                          <tr>
                            {/* Create headers for each day of the month */}
                            {[...Array(31)].map((_, index) => (
                              <td
                                style={{ fontSize: 12 }}
                                key={index + 1}
                                className="text-center"
                              >
                                {index + 1}
                              </td>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {teamData.map((employee) => (
                            <tr key={employee.company_user.id}>
                              {/* Employee details */}
                              <td style={{ fontSize: 12 }}>
                                {employee.company_user.emp_no}
                              </td>
                              <td style={{ fontSize: 12 }}>
                                {employee.company_user.first_name}{" "}
                                {employee.company_user.last_name}
                              </td>
                              <td style={{ fontSize: 12 }}>
                                {employee.company_user.position_name}
                              </td>
                              {/* Loop through each day of the month and display leave status */}
                              {[...Array(31)].map((_, day) => {
                                const leaveStatus =
                                  employee.leave_days[day + 1];
                                return (
                                  <td
                                    key={day + 1}
                                    style={{
                                      backgroundColor: leaveStatus?.eventBackgroundColor,
                                      width:30,
                                                height:30
                                    }}
                                  >
                                     <div
                                     className="w-100 h-100 d-lg-flex justify-content-center align-items-center"
                                             key={day + 1}
                                              style={{
                                                backgroundColor:
                                                leaveStatus?.eventBackgroundColor, // Event background color
                                                color: leaveStatus?.eventTextColor, // Event text color
                                                fontSize: "10px",
                                                // padding: "2px",
                                                
                                                // marginTop: "2px",
                                                // borderRadius: "4px",
                                              }}
                                            >
                                              {leaveStatus?.short_code }
                                            </div>
                                    {/* {leaveStatus ? leaveStatus.short_code : "-"} */}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="row mt-2">
                      {leaveTypeTeam.map((leave, index) => (
                        <div key={index} className="col-md-3 col-lg-4 col-sm-2   ">
                          <p className="card-text" style={{ fontSize: "10px" }}>
                            {leave.short_code} - {leave.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <div className="row mt-2">
                      {Object.entries(leaveColorTeam).map(
                        ([status, color], index) => (
                          <div key={index} className="col-md-3 col-lg-4 col-sm-2  ">
                            <div className="d-flex align-items-center mb-1">
                              <div
                                style={{
                                  height: "20px",
                                  width: "20px",
                                  backgroundColor: color,
                                  color: "#fff",
                                  // borderRadius: "8px",
                                  // fontWeight: "bold",
                                }}
                              />
                              <span className="ms-1" style={{ fontSize: 10 }}>
                                {status}
                              </span>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CalendarModal />
    </div>
  );
};

export default Calendar;
